import { gql } from "@apollo/client";

export const GET_PLAN_CUIDADO_LISTA_PRECIO = gql`
query GetPlanCuidadoListaPrecioTango(
  $idPlanCuidado: Int!
, $idCliente: String!) {
  planCuidadoListaPrecioTango (idPlanCuidado: $idPlanCuidado
  , idCliente: $idCliente ) {
    precio,
    tipoPrecio,
    vigencia,
    precioControl,
    codArticulo  
  } 
}
`;